import { useMemo } from 'react';
import PropTypes from 'prop-types';
import TablaLocal from '../tabla/TablaLocal';

export const COLUMNAS_ALUMNOS_ACTAS = [
  { id: 'ccodcli', label: 'ID', width: 110, sortable: true, filter: 'text' },
  { id: 'sNombre', label: 'Nombre', width: 180, sortable: true, filter: 'text' },
  { id: 'sApellidos', label: 'Apellidos', width: 220, sortable: true, filter: 'text' },
  { id: 'CDNICIF', label: 'Documento', width: 140, sortable: true, filter: 'text' },
];

const claveFila = (fila) => fila.ccodcli;
const tituloTarjeta = (fila) => `${fila.sNombre ?? ''} ${fila.sApellidos ?? ''}`.trim();
const SIN_DATA = [];
const SIN_ALUMNOS_IDS = [];
const SIN_ON_ALTERNAR = () => {};
const SIN_ON_ALTERNAR_VISIBLES = () => {};

const ListadoAlumnosActas = ({
  data = SIN_DATA,
  alumnosIds = SIN_ALUMNOS_IDS,
  onAlternar = SIN_ON_ALTERNAR,
  onAlternarVisibles = SIN_ON_ALTERNAR_VISIBLES,
}) => {
  const seleccion = useMemo(
    () => ({
      estaSeleccionada: (fila) => alumnosIds.includes(fila.ccodcli),
      alternar: (fila) => onAlternar(fila.ccodcli),
      alternarTodas: onAlternarVisibles,
    }),
    [alumnosIds, onAlternar, onAlternarVisibles],
  );

  return (
    <div className="mt-4">
      <TablaLocal
        tablaKey="actas"
        columnas={COLUMNAS_ALUMNOS_ACTAS}
        filas={data}
        nombreEntidad="alumnos"
        archivo="alumnos-actas"
        placeholder="Buscar alumno…"
        seleccion={seleccion}
        tituloTarjeta={tituloTarjeta}
        claveFila={claveFila}
      />
    </div>
  );
};

ListadoAlumnosActas.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  alumnosIds: PropTypes.array,
  onAlternar: PropTypes.func,
  onAlternarVisibles: PropTypes.func,
};

export default ListadoAlumnosActas;
